export const URL_TO_API = "https://api.serthoro.de/eps";
//export const URL_TO_API = "http://localhost:9000/";

export const OPTION_COPY_EP = "OPTION_COPY_EP";
export const OPTION_COPY_EXCEL = "OPTION_COPY_EXCEL";
export const OPTION_COPY_CUSTOM = "OPTION_COPY_CUSTOM";

export const MIN_DATE_EP_SELECT = new Date("2019-01-01T00:00:00");
export const MAX_DATE_EP_SELECT = new Date();
